import {
  CARD_PROJECT_CREATE_REQUEST,
  CARD_PROJECT_GET_REQUEST,
  CARD_PROJECT_UPDATE_REQUEST,
  CARD_PROJECT_DELETE_REQUEST,
  CARD_PROJECT_SUCCESS,
  CARD_PROJECT_FAIL,
  // For Card Layout Navbar  Sync/Reload (Credit Sheet)
  CARD_PROJECT_CREDITS_UPDATE_REQUEST,
  CARD_PROJECT_CREDITS_UPDATE_SUCCESS,
  // Sidebar Block Selection
  CARD_CURRENT_BLOCK_SELECT_SUCCESS,
  BLOCK_MOVE,
  // Layout Select Options Types Font/Layout
  CARD_OPTION_SELECT_TYPE_SUCCESS,
  // Layout
  CARD_OPTIONS_UPDATE_SUCCESS,
  // Layout Block Alignment Setting
  CARD_OPTIONS_CREDIT_UPDATE_SUCCESS,
  // Font
  CARD_FONT_UPDATE_SUCCESS,
  CARD_FONT_SAVE_SUCCESS,
} from "../../actions/types";

const initialState = {
  credits: null,
  currentBlock: { idx: 0, id: 0 },
  error: null,
  fontStyle: null,
  googleSheetLink: null,
  googleSpreadSheetId: null,
  isLoading: false,
  isVideoGenerated: null,
  lastSaved: null,
  lastSavedTime: new Date(),
  logos: [],
  members: [],
  renders: [],
  settings: null,
  isOptionSelected: "layout",
  resolution: null,
};

const CardProjectsReducer = (state = initialState, action) => {
  // console.log("action = ", action);

  switch (action.type) {
    // 1 Request ===================================================================================================
    case CARD_PROJECT_GET_REQUEST:
      return { ...state, isLoading: true };

    // 2 Fail ======================================================================================================
    case CARD_PROJECT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    // 3 GET Success ===============================================================================================
    case CARD_PROJECT_SUCCESS:
      const {
        _id,
        credits: _credits,
        members,
        googleSheetLink: _googleSheetLink,
        fontStyle: _fontStyle,
        settings: _settings,
        currentBlock: _currentBlock,
        logos: _logos,
        googleSpreadSheetId: _googleSpreadSheetId,
        isVideoGenerated: _isVideoGenerated,
        renders,
        title,
        projectStatus,
        resolution,
      } = action.payload;
      return {
        ...state,
        isLoading: false,
        _id,
        credits: _credits,
        members,
        fontStyle: _fontStyle,
        settings: _settings,
        currentBlock: _currentBlock,
        logos: _logos,
        googleSpreadSheetId: _googleSpreadSheetId,
        googleSheetLink: _googleSheetLink,
        isVideoGenerated: _isVideoGenerated,
        lastSavedTime: new Date(),
        renders,
        title,
        projectStatus,
        resolution,
      };

    // 4 For Card Layout Navbar  Sync/Reload (Credit Sheet) ========================================================
    case CARD_PROJECT_CREDITS_UPDATE_SUCCESS:
      return {
        ...state,
        credits: action.payload.credits,
        lastSavedTime: new Date(),
        isLoading: false,
      };

    // 5  Select Current Block Id From Sidebar And Preview =========================================================
    case CARD_CURRENT_BLOCK_SELECT_SUCCESS:
      const { id, idx } = action.payload;
      let currentBlock = state.currentBlock;
      currentBlock = { ...currentBlock, id, idx };
      return {
        ...state,
        currentBlock,
      };

    case BLOCK_MOVE:
      const { sourceIdx, targetIdx } = action.payload;
      const updatedCredits = [...state.credits];
      const [removed] = updatedCredits.splice(sourceIdx, 1);
      updatedCredits.splice(targetIdx, 0, removed);
      return {
        ...state,
        credits: updatedCredits,
      };

    // 6 Layout Select Options Types Font/Layout ===================================================================
    case CARD_OPTION_SELECT_TYPE_SUCCESS:
      return {
        ...state,
        isOptionSelected: action.payload,
      };

    case CARD_OPTIONS_CREDIT_UPDATE_SUCCESS:
      const { creditsIdx, optionKey, optionValue } = action.payload;
      const credits = [...state?.credits];
      if (optionValue === "sidebyside") {
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          ["side_by_side"]: "on",
        };
        credits[creditsIdx + 1].options = {
          ...credits[creditsIdx + 1]?.options,
          ["side_by_side"]: "on",
        };
      } else if (
        credits[creditsIdx - 1]?.options?.block_inset === "sidebyside"
      ) {
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          ["side_by_side"]: "on",
        };
      } else if (optionKey == "double_columns" && !optionValue) {
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          ["side_by_side"]: "off",
          ["text_alignment"]: "center",
        };
      }
      // for column and pragraph
      else if (optionKey == "bullets" && optionValue !== null) {
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          columns: 1,
          column_width: 100,
        };
      } else if (optionKey == "bullets" && optionValue === null) {
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          bullets: null,
          columns: 1,
          column_width: 100,
          side_by_side: "off",
        };
        if (credits.length - 1 !== creditsIdx) {
          credits[creditsIdx + 1].options = {
            ...credits[creditsIdx + 1]?.options,
            side_by_side: "off",
          };
        }
      } else if (optionKey == "columns") {
        const newColumns = Number(optionValue) || 1;
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          columns: newColumns,
          column_width: Math.floor(100 / newColumns),
          side_by_side: "off",
        };
        if (credits.length - 1 !== creditsIdx) {
          credits[creditsIdx + 1].options = {
            ...credits[creditsIdx + 1]?.options,
            side_by_side: "off",
          };
        }
      } else if (credits.length - 1 === creditsIdx) {
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          ["side_by_side"]: "off",
        };
      } else {
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          ["side_by_side"]: "off",
        };
        credits[creditsIdx + 1].options = {
          ...credits[creditsIdx + 1]?.options,
          ["side_by_side"]: "off",
        };
      }
      return {
        ...state,
        credits,
      };

    case CARD_OPTIONS_UPDATE_SUCCESS:
      const { options, creditsId } = action.payload;
      const _creditsIdx = state.credits.findIndex(
        (credit) => credit._id == creditsId
      );
      if (_creditsIdx === -1) return state;
      state.credits[_creditsIdx].options = options;
      return {
        ...state,
        isLoading: false,
        lastSavedTime: new Date(),
      };

    // Font Settings ==============================================================================
    // Font-Update
    case CARD_FONT_UPDATE_SUCCESS:
      const { key, property, value } = action.payload;
      return {
        ...state,
        fontStyle: {
          ...state.fontStyle,
          [key]: { ...state.fontStyle[key], [property]: value },
        },
      };
    // Font-Save
    case CARD_FONT_SAVE_SUCCESS:
      const {
        fontStyle: __fontStyle,
        fontStyleType,
        fontStyleBody,
      } = action.payload;
      return {
        ...state,
        fontStyle: {
          ...state.fontStyle,
          [fontStyleType]: __fontStyle,
          fontStyleBody: fontStyleBody,
        },
        lastSavedTime: new Date(),
        isLoading: false,
      };

    // Render Export  Settings ==================================================================================================

    // Logo Block Settings ==================================================================================================

    // 9 Render - Setting State Update ===================================================================
    default:
      return state;
  }
};

export default CardProjectsReducer;
